import {
  Ref, ref, computed,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export interface ResultUseCreateCustomQuery {
  loadingExportCustomQuery: Ref<boolean>;
  errorMessageExportCustomQuery: Ref<string>;
  exportCustomQueryDataToSpreadSheet: (payload: {
    spreadsheetId: string;
    sheetName: string;
    mode: string;
  }) => any;
  exportCutomQueryData: Ref<any>;
}

export default function useExportCustomQuery(): ResultUseCreateCustomQuery {
  const route = useRoute();
  const store = useStore();
  const projectSlug = computed(() => {
    const slugOrSlugs = route.params.slug;
    return Array.isArray(slugOrSlugs) ? slugOrSlugs[0] : slugOrSlugs;
  });

  const customQueryId = computed(() => {
    const slugOrSlugs = route.params.customQueryId;
    return Array.isArray(slugOrSlugs) ? slugOrSlugs[0] : slugOrSlugs;
  });

  const loadingExportCustomQuery = ref(false);
  const errorMessageExportCustomQuery = ref();
  const exportCutomQueryData = ref();

  const exportCustomQueryDataToSpreadSheet = async (payload: {
        spreadsheetId?: string,
        sheetName?: string,
        mode?: string,
        localFile?: string | null
      }) => {
    loadingExportCustomQuery.value = true;
    errorMessageExportCustomQuery.value = null;

    const { data, error } = await store.dispatch('customQuery/exportCustomQueryAction', {
      projectSlug: projectSlug.value,
      customQueryId: customQueryId.value,
      payload,
    });
    if (data) {
      exportCutomQueryData.value = data;
      errorMessageExportCustomQuery.value = null;
    } else {
      exportCutomQueryData.value = null;
      errorMessageExportCustomQuery.value = error;
    }
    loadingExportCustomQuery.value = false;

    return { data, error };
  };

  return {
    loadingExportCustomQuery,
    errorMessageExportCustomQuery,
    exportCustomQueryDataToSpreadSheet,
    exportCutomQueryData,
  };
}
